class Drawer extends HTMLElement {
  constructor() {
    super();
    this.attachShadow({ mode: "open" });

    // Tạo HTML và CSS cho drawer
    this.shadowRoot.innerHTML = `
          <style>
              :host {
                position: fixed;
                inset: 0;
                width: 100%;
                height: 100%;
                pointer-events: none;

              }
              :host([open]) .overlay {
                opacity: 1;
                visibility: visible;
              }
              
              :host([open]) .content{
                visibility: visible;
                transform: translateX(0);
              }

              .overlay{
                position: absolute;
                inset: 0;
                z-index: 1;
                background-color: rgba(0,0,0,.4);
                cursor: pointer;
                transition: .25s ease;
                opacity: 0;
                visibility: hidden;
                pointer-events: auto;
              }
              .header{
                display: flex;
                align-items: center;
                justify-content: space-between;
                width: 100%;
              }
              .content {
                z-index: 2;
                position: absolute;
                top: 0;bottom: 0;right: 0;width: 100%;
                max-width: min(650px,25%);
                display: grid;
                grid-template-rows: auto 1fr auto;
                background-color: #fff;
                padding: 30px 20px 30px 30px;
                transition: .25s ease;
                transition-delay: .05s;
                transform: translateX(100%);
                visibility: hidden;
                pointer-events: auto;
              }
              .body{
                max-height: 100vh;
                overflow-y: auto;
              }
              .body::-webkit-scrollbar {
                height: 5px; /* height of horizontal scrollbar ← You're missing this */
                width: 5px; /* width of vertical scrollbar */
              }

              .body::-webkit-scrollbar-track {
                background-color: rgba(0, 0, 0, 0.05);
              }

              .body::-webkit-scrollbar-thumb{
                background-color: rgba(0, 0, 0, 0.12);
              }
              .close-btn {
                width: 40px;
                height: 40px;
                display: flex;
                align-items: center;
                justify-content: center;
                border: none;
                background-color: transparent;
                margin-inline-start: auto;
                cursor:pointer;
                margin-top: -40px;
                margin-inline-end: -10px;
              }
              .close-btn svg {
                width: 50px;
                height: 50px;
              }
              @media(max-width: 767px) {
                .content {
                  max-width: 73%;
                  padding: 20px 15px 20px 20px;
                }
                .close-btn {
                  margin-top: -30px;
                  margin-inline-end: -10px;
                }
                .content .page_content-heading,
                .content h1 {
                  font-size: 25px;
                  line-height: 30px;
                  margin-bottom: 10px;
                }
              }
          </style>
          <div class="modal">
            <div class="overlay"></div>
            <div class="content">
              <div class="header">
                <h3 name="header"></h3>
                <button class="close-btn"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z"/></svg></button>
              </div>
              <div class="body">
                <slot></slot>
              </div>
              <div class="footer">
                <slot></slot>
              </div>
            </div>
          </div>
      `;

    // Thêm sự kiện click cho nút đóng drawer
    if(window.innerWidth > 768){
      this.shadowRoot
      .querySelector(".close-btn")
      .addEventListener("click", () => {
        this.close();
      });
      this.shadowRoot.querySelector(".overlay").addEventListener("click", () => {
        this.close();
      });
    }else{

      this.shadowRoot
        .querySelector(".close-btn")
        .addEventListener("touchstart", () => {
          this.close();
        });
      this.shadowRoot.querySelector(".overlay").addEventListener("touchstart", () => {
        this.close();
      });
    }
  }

  // Phương thức mở drawer
  open() {
    // Di chuyển drawer vào cuối body
    document.body.appendChild(this);
    // Kích hoạt animation mở
    requestAnimationFrame(() => {
      this.setAttribute("open", "");
      document.body.classList.add("t4s-lock-scroll");
    });
  }

  // Phương thức đóng drawer
  close() {
    // Kích hoạt animation đóng
    this.removeAttribute("open");
    document.body.classList.remove("t4s-lock-scroll");
  }
}

// Đăng ký custom element
customElements.define("kxti-drawer", Drawer);

// Thêm sự kiện click cho nút mở drawer
document.querySelectorAll('[is="openDrawerBtn"]').forEach((btn) => {
  btn.addEventListener("click", (event) => {
    const controlledId = event.target.getAttribute("aria-controls");
    const drawer = document.getElementById(controlledId);
    if (drawer) {
      drawer.open();
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelector('html').style.scrollBehavior = 'smooth';
  // const sections = document.querySelectorAll('main section');
  let sections=[];
  const navLinks = document.querySelectorAll('.spy-item .spy-link');
  navLinks.forEach((link,index) => {
    link.setAttribute('href',`#${link.dataset.idConnect}`);
    let section = document.getElementById(link.dataset.idConnect);
    sections.push(section);
  })
  let activeIndices = [];

  window.addEventListener('scroll', () => {
    sections.forEach((section, index) => {
      const sectionTop = section.offsetTop;
      const sectionHeight = section.clientHeight;

      if (pageYOffset >= sectionTop - sectionHeight / 3) {
        if (!activeIndices.includes(index)) {
          activeIndices.push(index);
        }
      } else {
        const idx = activeIndices.indexOf(index);
        if (idx > -1) {
          activeIndices.splice(idx, 1);
        }
      }
    });

    navLinks.forEach((link, index) => {
      if (activeIndices.includes(index)) {
        link.classList.add('is--active');
        // console.log(activeIndices.length,sections.length);
        // [0,1,2,3,4,5] 6 
        if(sections.length == activeIndices.length){
          setTimeout(() => {
            document.querySelector('kxti-observer').classList.add('kxti_ob_hidden');
          }, 1500);
        }else{
          document.querySelector('kxti-observer').classList.remove('kxti_ob_hidden');
        }
      } else {
        link.classList.remove('is--active');
      }
    });
  });
});

// document.addEventListener('DOMContentLoaded', () => {
//   document.querySelector('html').style.scrollBehavior = 'smooth';
//   const sections = document.querySelectorAll('main section');
//   const navLinks = document.querySelectorAll('.spy-item .spy-link');
//   navLinks.forEach((link,index) => {
//     link.setAttribute('href',`#${sections[index].id}`);
//   })
//   let activeIndices = [];

//   window.addEventListener('scroll', () => {
//     sections.forEach((section, index) => {
//       const sectionTop = section.offsetTop;
//       const sectionHeight = section.clientHeight;

//       if (pageYOffset >= sectionTop - sectionHeight / 3) {
//         if (!activeIndices.includes(index)) {
//           activeIndices.push(index);
//         }
//       } else {
//         const idx = activeIndices.indexOf(index);
//         if (idx > -1) {
//           activeIndices.splice(idx, 1);
//         }
//       }
//     });

//     navLinks.forEach((link, index) => {
//       if (activeIndices.includes(index)) {
//         link.classList.add('is--active');
//       } else {
//         link.classList.remove('is--active');
//       }
//     });
//   });
// });


// Menu mobile custom
$(document).on('click','[menucustom-cta]',function(e){
  e.preventDefault();
  $(this).toggleClass('is--closing');
  $('#mobile-nav-custom').toggleClass('is--open');
  document.body.classList.toggle('t4s-custom-menu');
});
class MenuMobileCustom extends HTMLElement{
  constructor(){
    super();
    this.overlay = this.querySelector('.overlay');
    this.btn_close = this.querySelector('.mnmb-close');
    this.arr_accordion = this.querySelectorAll('.t4s-menu-item > a');
    this.overlay.addEventListener('click',()=>{
      this.close();
      document.querySelector('[menucustom-cta]').classList.add('is--closing');
    })
    this.btn_close.addEventListener('click',()=>{
      this.close();
      document.querySelector('[menucustom-cta]').classList.add('is--closing');
    })
    this.arr_accordion.forEach(el => {
      el.addEventListener('click',function(e){
        e.preventDefault();
        let parent = this.closest('.t4s-menu-item');
        let content = parent.querySelector('.t4s-sub-menu');
        if(this.classList.contains('is--active')){
          content.style.height = 0;
          this.classList.remove('is--active');
        }else{
          this.classList.add('is--active');
          content.style.height = `${content.scrollHeight}px`;
        }
      })
    })
  }
  open(){
    this.classList.add('is--open');
    
  }
  close(){
    this.classList.remove('is--open');
    document.body.classList.remove('t4s-custom-menu');
  }

}
customElements.define('menumobile-custom',MenuMobileCustom);

class kxtiCustom extends HTMLElement {
  constructor() {
    super();
    this.config = JSON.parse(this.getAttribute("config"));
    if (!this.config) {
      this.config = {
        time_delay: 3500,
        loop: false,
      };
    }
    this.img_slider = this.querySelector(".kxti-img-slider");
    this.content_slider = this.querySelector(".kxti-content-slider");
    this.img__slider = new Flickityt4s(this.img_slider, {
      contain: true,
      wrapAround: this.config.loop,
      pageDots: false,
      prevNextButtons: false,
      autoPlay: parseInt(this.config.time_delay),
      fade: true

    });
    console.log("--Slider banner config: ", this.config);
    this.flickity_img = Flickityt4s.data(this.img_slider);
    if (window.innerWidth < 767) {
      this.content__slider = new Flickityt4s(this.content_slider, {
        wrapAround: true,
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        asNavFor: ".kxti-img-slider",
        adaptiveHeight: true
      });
      this.content__slider.on("change", (index) => {
        const cell_content = this.content__slider.cells[index].element;
        const data_index_content = cell_content.dataset.index;
        // cell_content.dispatchEvent(new Event('click',{bubbles: false}));
        this.flickity_img.select(data_index_content);
      });
    }
    this.onChange();
    this.contentClick();

    this.addEventListener('mousemove',( ) =>{
      this.classList.add('on-hover');
      this.img__slider.pausePlayer();
      // this.content__slider.pausePlayer();
    })
    this.addEventListener('mouseleave', ( ) => {
      this.classList.remove('on-hover');
      this.img__slider.unpausePlayer();
      // this.content__slider.unpausePlayer();

    })
  }
  onChange() {
    this.img__slider.on("change", (index) => {
      const cell = this.img__slider.cells[index].element;
      const data_index = cell.dataset.index;
      this.content_slider
        .querySelector(`.is-selected`)
        .classList.remove("is-selected");
      this.content_slider
        .querySelector(`[data-index="${data_index}"]`)
        .classList.add("is-selected");
      if (window.innerWidth > 767) {
        this.content_slider.querySelectorAll(`.kxti-content`).forEach((el) => {
          el.style.height = "0px";
        });
        const content_item = this.content_slider.querySelector(
          `[data-index="${data_index}"] .kxti-content`
        );
        content_item.style.height = content_item.scrollHeight + "px";
      }
    });
  }
  contentClick() {
    if (!this.content_slider) {
      return;
    }
    if (window.innerWidth < 767) {
      return;
    }

    this.content_slider
      .querySelectorAll(".kxti-content-item")
      .forEach((item) => {
        item.addEventListener("click", () => {
          const content_index = item.dataset.index;
          this.flickity_img.select(content_index);
          console.log(item);
        });
      });
  }
}
customElements.define("kxti-custom", kxtiCustom);

// handle mega menu
class kxtiCustomMega extends HTMLElement {
  constructor() {
    super();
    this.top_menu = this.querySelectorAll("[is-top-menu]");
    this.product_hover = this.querySelectorAll("[kxti-data-image]");
    this.init();
  }
  init() {
    this.top_menu.forEach((el) => {
      if(el.dataset.handle.toLowerCase().trim() == 'shop all'){
        return;
      }
      el.addEventListener("mouseover", () => {
        const mega_content_id = el.getAttribute("aria-controls");
        const content_mega = this.querySelector(`#${mega_content_id}`);
        if(!content_mega){
          return;
        }
        this.querySelector("[is-top-menu].is--hover").classList.remove(
          "is--hover"
        );
        this.querySelector(
          ".kxti-custom-mega-item.is--active"
        )?.classList.remove("is--active");
        el?.classList.add("is--hover");

        content_mega.classList.add("is--active");
      });
    });

    this.product_hover.forEach((product) => {
      product.addEventListener("mouseover", () => {
        const parent = product.closest(".kxti-custom-mega-item");
        const data_image = product.getAttribute("kxti-data-image");
        const banner = parent.querySelector(".t4s-mega-banner-item img");
        if (data_image) {
          banner.src = data_image;
          banner.srcset = data_image;
        }
      });
    });
  }
}
customElements.define("kxti-custom-mega", kxtiCustomMega);


//kxti-video-data

// add remore


document.addEventListener('DOMContentLoaded', ()=> {
  const list_menu =  document.querySelectorAll('[data-menu-nav] > li ');
  list_menu.forEach(menu => {
    menu.addEventListener('mouseenter',()=> {
      document.body.classList.add('menu--hover');
    })
    menu.addEventListener('mouseleave',()=> {
      document.body.classList.remove('menu--hover');
    })
  })
}) 

// tasb video
class TabsVideo extends HTMLElement{
  constructor(){
    super();
    // this.config = JSON.parse(this.getAttribute('config'));
    this.tabs =this.querySelectorAll('[tab-item]');
    // this.video = this.querySelector('[is--active] video');
    if(!this.tabs){
      return;
    }
    this.tabs.forEach(tab => {
      tab.addEventListener('click', () => {
        this.onClick(tab);
      })
    })
    // this.videoHandle();
  }
  onClick(tab){
    const content_id = tab.getAttribute('aria-controls');
    const content = document.querySelector(`#${content_id}`);
    const video = document.querySelector(`#${content_id} video`);

    document.querySelector('.t4s-tabs-content[is--active]')?.removeAttribute('is--active');
    this.querySelector('[is--active][tab-item]').removeAttribute('is--active');


    content.setAttribute('is--active','');
    tab.setAttribute('is--active','')

    video.currentTime = 0;
  }
}

customElements.define('tabs-custom',TabsVideo);


// popup video

document.addEventListener('DOMContentLoaded', function() {
  const closePopup = document.querySelector('.kxti-popup #closeVideoPopup');
  const overlayPopup = document.querySelector('.kxti-popup .overlay')
  const videoPopup = document.querySelector('.kxti-popup#videoPopup');
  const videoContainer = document.querySelector('.kxti-popup #videoContainer');
  let arr_href = document.querySelector('kxti-youtube-popup [href]');
  let video_source = arr_href?.getAttribute('href')

  function popupVideoShopify(arr_href,video_source,closePopup,videoPopup,videoContainer,overlayPopup){
    let videoTag;
    if(video_source?.includes('.shopify')){
      videoTag = `<video width="100%" controls autoplay loop>
                          <source src="${video_source}" type="video/mp4">
                          Trình duyệt của bạn không hỗ trợ video tag.
                        </video>`;
    }else{
      const videoId = video_source?.split('v=')[1];
      const embedLink = `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      videoTag = `<iframe width="100%" height="500" src="${embedLink}" frameborder="0" allowfullscreen></iframe>`
    }
    arr_href?.addEventListener('click', (e) => {
      e.preventDefault();
      videoContainer.innerHTML = videoTag;
      videoPopup.style.display = 'flex';
      videoPopup.style.pointerEvents="auto";
    });
  
    closePopup.addEventListener('click', () => {
      videoPopup.style.display = 'none';
      videoPopup.style.pointerEvents="none";
      videoContainer.innerHTML = '';
    });
    overlayPopup.addEventListener('click', () => {
      videoPopup.style.display = 'none';
      videoPopup.style.pointerEvents="none";
      videoContainer.innerHTML = '';
    });
  }
  popupVideoShopify(arr_href,video_source,closePopup,videoPopup,videoContainer,overlayPopup);
});